"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.InlineResponse20018ToJSON = exports.InlineResponse20018FromJSONTyped = exports.InlineResponse20018FromJSON = void 0;
var _1 = require("./");
function InlineResponse20018FromJSON(json) {
    return InlineResponse20018FromJSONTyped(json, false);
}
exports.InlineResponse20018FromJSON = InlineResponse20018FromJSON;
function InlineResponse20018FromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'discounts': (json['discounts'].map(_1.MenuOrderDiscountFromJSON)),
    };
}
exports.InlineResponse20018FromJSONTyped = InlineResponse20018FromJSONTyped;
function InlineResponse20018ToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'discounts': (value.discounts.map(_1.MenuOrderDiscountToJSON)),
    };
}
exports.InlineResponse20018ToJSON = InlineResponse20018ToJSON;
